<template>
  <div class="login-layout" >
    <div class="login-center" :style="bg1">
      <div class="login-main w1200">
        <div class ="form-main">
          <div class="login-top">
            <img :src="assoInfo.logo" alt="">
            <p class="top-title">{{assoInfo.name}}</p>
          </div>
          <div class="form-content">
            <div class="step-title">{{resetTitle()}}</div>
            <StepOne v-if="step === '1'" v-on:getStep="changeStep"></StepOne>
            <stepTwo v-if="step === '2'" @preEvent="preEvent" @nextEvent="nextEvent"></stepTwo>
            <stepThree v-if="step === '3'"></stepThree>
          </div>
        </div>
      </div>
    </div>
    <!-- <CopyRight></CopyRight> -->
  </div>
</template>

<script>
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import StepOne from '@/components/register/components/stepOne'
import stepTwo from '@/components/register/components/stepTwo'
import stepThree from '@/components/register/components/stepThree'
export default {
  name: 'Register',
  components: {
    HeaderNav,
    CopyRight,
    StepOne,
    stepTwo,
    stepThree
  },
  data () {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系方式'))
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的电话'))
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      step: '1',
      stepTitle: '输入账户信息',
      titleMsg: '登录',
      checked: true,
      radio: '1',
      num1: 0,
      ruleForm: {
        pass: '',
        checkPass: '',
        userName: ''
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
        userName: [
          { validator: phoneRules, trigger: 'blur' }
        ]
      },
      fileList: [],
      bg1: {
        backgroundImage: 'url(/static/images/login-bg.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0px 0px',
        backgroundSize: '100% 100%'
      },
      assoInfo: JSON.parse(localStorage.getItem('assoInfo')),
      isActive: '0'
    }
  },
  methods: {
    resetTitle () {
      if (this.step === '1') {
        return '输入账户信息'
      } else if (this.step === '2') {
        return '输入会员信息'
      } else if (this.step === '3') {
        return '上传资料'
      }
    },
    changeStep (stepNum) {
      this.step = stepNum
    },
    preEvent (stepNum) {
      this.step = stepNum
    },
    nextEvent (stepNum) {
      this.step = stepNum
    },
    isClick () {
      if (this.checked) {
        this.checked = false
      } else {
        this.checked = true
      }
    },
    lfetBarClick (item) {
      this.isActive = item.id
    },
    handleChange (value) {
      console.log(value)
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 登录
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 注册
    resignForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改密码
    updataForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  mounted () {

    // changeStep (stepNum){
    //   debugger
    //   this.step = stepNum
    // }
  },
  created () {
    // this.bg1.height = this.getHeight() + 'px'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-layout {
    width: 100%;
    height:100vh;
  }
  .login-center {
    width: 100%;
    height: 100%;
    padding:50px 0px;
    /* background-color: #0a4181; */
  }
  .form-content{
    margin-top: 50px;
    width: 500px;
    padding: 20px 50px;
    margin: 50px auto;
    background: rgb(45,71,151);
    /* opacity: 0.5; */
    border-radius: 10px;
  }
  .step-title{
    color: #fff;
    text-align: center;
    padding: 20px 0px;
  }
  .form-main{
    width: 880px;
    margin: 0px auto 0px auto;
  }
  .login-top{
    text-align: center;
  }
  .login-top img{
   display: inline-block;
    width: 152px;
    height: 61px;
    overflow: hidden;
  }
  .login-top .top-title{
    font-size: 40px;
    color:#fff;
    margin-top:10px;
  }
.fixd {
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/register/Index.vue